<template>
  <div v-if="records && records.length" class="record-box">
    <div
      class="record-items" 
      v-for="(item, index) in records" 
      :key="item.record_id"
      @click="selfToAnswer(item.record_id)"
    >
      <div v-if="temp !== 3">
        <div class="record-detail">
          <div class="detail-item">
            <div class="dt">{{ item.all }}</div>
            <div class="ds">总题数</div>
          </div>
          <label v-if="index === 0 && page === 1" class="tag">新</label>
          <div class="detail-item">
            <div class="dt">{{ item.right }}</div>
            <div class="ds">答对</div>
          </div>
          <div class="detail-item">
            <div class="dt">
              {{ item.time }}
            </div>
            <div class="ds">用时</div>
          </div>
          <div class="detail-item">
            <div class="dt" :class="{ 'blue': item.score != '-' }">{{ item.score }}</div>
            <div class="ds">得分</div>
          </div>
        </div>
        <div class="rec-time"  @click.stop="selfToAnswer(item.record_id, 1)">{{ item.t_add }} 提交，查看详情 ></div>
      </div>
      <div v-else>
        <div class="temp3-detail">
          <label v-if="index === 0 && page === 1" class="tag">新</label>
          <div class="detail-item-temp3">
            <div class="temp3-l">{{ item.t_add }} 提交</div>
            <div class="temp3-r"  @click.stop="selfToAnswer(item.record_id, 1)">查看详情 ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    records: {
      type: Array,
      default: []
    },
    temp: {
      type: Number,
      default: 0
    },
    showlist: {
      type: Boolean,
      default: false
    },
    page: {
      type: Number,
      default:  1
    },
    vip: {
      type: Number,
      default:  0
    }, 
    owner_vip: {
      type: Number,
      default:  0
    },
    show_answer: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  methods:{
    selfToAnswer(rid, second) {
      if(!wemeet.app.isTMWebview() && !this.vip) {
        this.$emit('handleVipTip')
      }else {
        let name = 'normalResult';
        if(second && this.show_answer != 1) {
          name = this.temp == 5 ? 'answerTacit' : 'answerNormal'
        }
        this.$router.push({name, query: {rid: rid}})
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.record-box{
  padding: 0 15px 15px;
  background: #fff;
  position: relative;
}
.record-items{
  background: #F5F7FA;
  border-radius: 4px;
  padding: 10px 15px;
  font-size: 15px;
  position: relative;
  cursor: pointer;
}
.record-items.mb20 {
  margin-bottom: 10px;
}
.temp3-detail {
  background: #F5F7FA;
  border-radius: 4px;
  padding: 5px 0;
}
.record-detail {
  display: flex;
  align-items: center;
  padding: 5px 0 15px 0;
  justify-content: space-between;
}
.record-detail .tag, .temp3-detail .tag {
  position: absolute;
  right: 0;
  top: 0;
  background: #1890FF;
  width: 25px;
  height: 17px;
  border-radius: 0 4px 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #ffffff;
}
.detail-item {
  flex: 1;
  text-align: center;
}
.detail-item:first-child {
  max-width: 65px;
}
.detail-item:last-child {
  margin-right: 0;
}
@media screen and (min-width: 500px) { // 当屏幕宽度大于或等于 500px 时应用的样式规则
  .detail-item:first-child {
    max-width: 85px;
  }
}
.dt {
  line-height: normal;
  margin-bottom: 3px;
  font-size: 17px;
  font-weight: 700;
}
.dt.blue {
  color: #1890ff;
}
.ds {
  font-size: 12px;
  color: #999999;
}
.rec-time {
  border-top: 1px solid rgba(204, 204, 204, 0.3);
  padding-top: 10px;
  text-align: right;
  font-size: 13px;
  color: #999999;
}
.dt-mini {
  /* font-size: 24rpx; */
}
.detail-item-temp3 {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.temp3-r {
  font-size: 13px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/recordList.vue